import React, { useEffect, useMemo, useState } from "react";
import { fnGetDataSet } from "@shared/api/restApi";
import { global } from "@shared/libs/Global";
import { formatNumber, toNum } from "@shared/utils/CommonUtils";
import { icoDlv } from "./icons";

interface Props {
  cdWidget?: string;
  nmWidget?: string;
  searchData?: any;
  refreshKey?: number;
}

const SnSysWidget007: React.FC<Props> = ({
  nmWidget,
  searchData,
  refreshKey,
}) => {
  const { userInfo } = global();
  const [dataSource, setDataSource] = useState<any>();

  const params = useMemo(
    () => ({
      cd_firm: searchData?.cd_firm || userInfo.cd_firm,
      dt: searchData?.dt,
    }),
    [searchData?.cd_firm, searchData?.dt, userInfo.cd_firm]
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const param = {
          id: "sn_sys_widget_007_01",
          params,
        };
        const data: any = await fnGetDataSet(param);
        setDataSource(data?.[0]?.[0] || {});
      } catch (error) {}
    };

    fetchData();
  }, [params, refreshKey]);

  const rows = [
    {
      label: "지연건수",
      count: formatNumber(toNum(dataSource?.qt_delay_cnt), {
        fractionDigits: 0,
      }),
      qty: formatNumber(toNum(dataSource?.qt_delay), { fractionDigits: 0 }),
      unit: "개",
    },
    {
      label: "임박건수(1주)",
      count: formatNumber(toNum(dataSource?.qt_due_soon_cnt), {
        fractionDigits: 0,
      }),
      qty: formatNumber(toNum(dataSource?.qt_due_soon), {
        fractionDigits: 0,
      }),
      unit: "개",
    },
    {
      label: "납기완료건수",
      count: formatNumber(toNum(dataSource?.qt_done_cnt), {
        fractionDigits: 0,
      }),
      qty: formatNumber(toNum(dataSource?.qt_done), { fractionDigits: 0 }),
      unit: "개",
    },
  ];

  return (
    <div className="flex h-full min-h-[174px] w-full flex-col rounded-lg border border-gray-100 bg-white px-4 py-3 shadow-sm">
      <div className="mb-4 flex items-center gap-3">
        <div className="flex min-w-0 items-center gap-3">
          <div className="aspect-square h-10 shrink-0">
            <img src={icoDlv} alt="" className="h-full w-full object-contain" />
          </div>
          <div className="truncate text-xl font-bold text-slate-900">
            {nmWidget}
          </div>
        </div>
      </div>

      <div className="flex flex-1 flex-col gap-2.5">
        {rows.map((row) => (
          <div
            key={row.label}
            className="flex w-full items-baseline text-base font-semibold"
          >
            <span className="min-w-0 flex-1 truncate pr-3 text-slate-800">
              {row.label}
            </span>

            <div className="ml-auto grid shrink-0 grid-cols-[80px_118px] items-baseline gap-3">
              <span className="whitespace-nowrap text-right text-slate-900">
                {row.count}
                <span className="ml-1 text-sm font-semibold text-slate-700">
                  건
                </span>
              </span>
              <span className="whitespace-nowrap text-right text-slate-900">
                {row.qty}
                <span className="ml-1 text-sm font-semibold text-slate-700">
                  {row.unit}
                </span>
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SnSysWidget007;
